import React, { useState } from "react";
import {
  multiDayReport,
  useMultiDayEventContext,
} from "contexts/MultiDayEventContext";
import styled from "styled-components";
import { Card, NoData, InfoBars } from "Components";
import { Modal } from "Components/Modal";
import { CardTitle } from "Routes/SetLive/ShowDetails/Components/CardTitle";
import { Loader } from "./Loader";

interface Props {
  dataKey: keyof multiDayReport;
  title: string;
  infoBarsProps?: Omit<React.ComponentProps<typeof InfoBars>, "data">;
}

const MAX_ITEMS = 5;

export const MetricCard: React.FC<Props> = ({
  dataKey,
  title,
  infoBarsProps,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { multiDayReport, multiDayReportLoading } = useMultiDayEventContext();

  const toggleModalOpen = () => setIsModalOpen((open) => !open);

  const list = multiDayReport?.[dataKey]
    ? Object.entries(multiDayReport[dataKey]).map(([label, value]) => ({
        label,
        value,
      }))
    : [];

  return (
    <>
      <StyledCard
        action={
          !multiDayReportLoading &&
          list.length > MAX_ITEMS && {
            text: "View All",
            onClick: toggleModalOpen,
            icon: false,
            textColor: "var(--main-color)",
          }
        }
        isElevated
      >
        {multiDayReportLoading ? (
          <Loader />
        ) : (
          <>
            <CardTitle>{title}</CardTitle>

            {list.length > 0 ? (
              <InfoBars data={list} limit={MAX_ITEMS} {...infoBarsProps} />
            ) : (
              <NoData />
            )}
          </>
        )}
      </StyledCard>
      <Modal isOpen={isModalOpen} header={title} onClose={toggleModalOpen}>
        <InfoBars data={list} {...infoBarsProps} />
      </Modal>
    </>
  );
};

const StyledCard = styled(Card)`
  margin-top: 0;
`;
